import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import validaciones from './libs/utils/validaciones'

require('./plugins');

Vue.config.productionTip = false

Vue.use(validaciones)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
